import React, { useContext } from 'react';
import { GridApi, GridOptions } from 'ag-grid-community';
import { formatDOBFromPim } from '@mummssoftware/utils/formatters';
import { PatientsListingContext } from '../../context';
import { AgGridTable } from './Table';
import { ListingContext } from '../Context/ListingContext';
import { SET_PATIENT_NUMBER } from '../Context/constants';
interface PatientsListingTableProps {
  viewModePrint?: boolean;
  smallWidget?: boolean;
}

export const PatientsListingTable = ({
  viewModePrint,
  smallWidget,
}: PatientsListingTableProps) => {
  const { patientsList } = useContext(PatientsListingContext);
  const { dispatch } = useContext(ListingContext);

  const patientsListing = patientsList?.map((p: mumms.patient) => ({
    ...p,
    formattedDOB: p.dateOfBirth && formatDOBFromPim(p.dateOfBirth),
  }));

  const columnDefs = smallWidget
    ? [
        {
          headerName: 'Patient ID',
          field: 'patientNumber',
          cellClass: 'no-border',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Last Name',
          field: 'lastName',
          cellClass: 'no-border',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'First Name',
          field: 'firstName',
          cellClass: 'no-border',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'DOB',
          field: 'formattedDOB',
          cellClass: 'no-border',
        },
      ]
    : [
        {
          headerName: 'Patient ID',
          field: 'patientNumber',
          cellClass: 'no-border',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Last Name',
          field: 'lastName',
          cellClass: 'no-border',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'First Name',
          field: 'firstName',
          cellClass: 'no-border',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'DOB',
          field: 'formattedDOB',
          cellClass: 'no-border',
        },
        {
          headerName: 'Payer Type',
          field: 'payerType',
          cellClass: 'no-border',
        },
        {
          headerName: 'LOC',
          field: 'loc',
          cellClass: 'no-border',
        },
        {
          headerName: 'Site',
          field: 'siteName',
          cellClass: 'no-border',
        },
      ];

  const gridOptions: GridOptions = {
    defaultColDef: {
      resizable: false,
      filter: true,
    },
    onCellClicked(event: any) {
      dispatch({
        type: SET_PATIENT_NUMBER,
        payload: event.data.patientNumber,
      });
    },
    columnDefs,
    onGridReady: (params: any) => {
      const gridApi: GridApi = params.api;
      gridApi.sizeColumnsToFit();
      // for PRINT to work!
      if (gridApi) {
        if (viewModePrint) {
          gridApi.setDomLayout('print');
        }
      }
    },
  };

  return (
    <React.Fragment>
      <AgGridTable
        gridOptions={gridOptions}
        rowData={patientsListing || []}
        smallWidget={smallWidget}
      />
    </React.Fragment>
  );
};

export default PatientsListingTable;
